export default __webpack_public_path__ + "static/media/favicon.6039d62a.ico";